function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.12207 5.85693L10.3743 3.94601L10.6308 4.65101L5.37857 6.56193L5.12207 5.85693Z",
  fill: "#9594AC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8575 5.14062L13.3878 4.61037L19.3868 10.6094L18.8565 11.1396L12.8575 5.14062Z",
  fill: "#9594AC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8232 11.4917L13.9252 10.7488L18.4267 11.3666L18.3247 12.1095L13.8232 11.4917Z",
  fill: "#9594AC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.70349 7.64893L5.03874 6.97843L11.036 9.97707L10.7008 10.6476L4.70349 7.64893Z",
  fill: "#9594AC"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.95496 17.5278L5.29112 16.857L10.6612 19.548L10.325 20.2189L4.95496 17.5278Z",
  fill: "#9594AC"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.625 12.375H12.375V18.75H11.625V12.375Z",
  fill: "#9594AC"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M4.39978 14.793L10.7185 5.04777L11.3477 5.45577L5.02903 15.201L4.39978 14.793Z",
  fill: "#9594AC"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9878 19.0415L18.9041 12.8512L19.4464 13.3694L13.53 19.5598L12.9878 19.0415Z",
  fill: "#9594AC"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M4.38599 8.54248L5.03099 8.15923L11.2122 18.5621L10.5672 18.9454L4.38599 8.54248Z",
  fill: "#9594AC"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M6.375 16.5C6.375 16.9237 6.2775 17.3213 6.0975 17.6738C5.67 18.5363 4.7775 19.125 3.75 19.125C2.29875 19.125 1.125 17.9513 1.125 16.5C1.125 15.0488 2.29875 13.875 3.75 13.875C4.27875 13.875 4.76625 14.0287 5.175 14.295C5.89875 14.7637 6.375 15.5738 6.375 16.5Z",
  fill: "#D6D4EC"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9913 18.5438C14.3888 19.0013 14.625 19.5975 14.625 20.25C14.625 21.7013 13.4513 22.875 12 22.875C10.5488 22.875 9.375 21.7013 9.375 20.25C9.375 19.9462 9.4275 19.6575 9.52125 19.3875C9.70125 18.8588 10.0462 18.4125 10.4962 18.0975C10.92 17.7975 11.4375 17.625 12 17.625C12.7987 17.625 13.515 17.9813 13.9913 18.5438Z",
  fill: "#D6D4EC"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M20.25 9.375C21.7013 9.375 22.875 10.5488 22.875 12C22.875 13.4513 21.7013 14.625 20.25 14.625C19.545 14.625 18.9075 14.3512 18.4387 13.8937C17.9362 13.4212 17.625 12.7462 17.625 12C17.625 11.88 17.6325 11.7637 17.6512 11.6475C17.7262 11.0625 17.9962 10.5412 18.3937 10.1437C18.87 9.6675 19.5225 9.375 20.25 9.375Z",
  fill: "#D6D4EC"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5988 11.2275C14.43 12.51 13.3312 13.5 12 13.5C10.5488 13.5 9.375 12.3263 9.375 10.875C9.375 10.4513 9.4725 10.0538 9.6525 9.70125C10.08 8.83875 10.9725 8.25 12 8.25C13.4513 8.25 14.625 9.42375 14.625 10.875C14.625 10.995 14.6175 11.1113 14.5988 11.2275Z",
  fill: "#D6D4EC"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M12 1.125C13.4513 1.125 14.625 2.29875 14.625 3.75C14.625 4.4775 14.3325 5.13 13.8563 5.60625C13.38 6.0825 12.7275 6.375 12 6.375C11.4713 6.375 10.9838 6.22125 10.575 5.955C10.0988 5.6475 9.7275 5.19 9.5325 4.64625C9.43125 4.36875 9.375 4.065 9.375 3.75C9.375 2.29875 10.5488 1.125 12 1.125Z",
  fill: "#D6D4EC"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M6.2175 5.85375C6.31875 6.13125 6.375 6.435 6.375 6.75C6.375 7.17375 6.2775 7.57125 6.0975 7.92375C5.8725 8.37375 5.52375 8.74875 5.0925 9.00375C4.7025 9.24 4.24125 9.375 3.75 9.375C2.29875 9.375 1.125 8.20125 1.125 6.75C1.125 5.29875 2.29875 4.125 3.75 4.125C4.88625 4.125 5.85 4.845 6.2175 5.85375Z",
  fill: "#D6D4EC"
});

var SvgAlgorithmic = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlgorithmic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/algorithmic.1396f5ea.svg";
export { ForwardRef as ReactComponent };